import React from 'react';
import { displayStatus } from '../format.ts';

export const SopStatusBadge: React.FC<{ status: string; run?: { status: string; progress?: number } }> = ({ status, run }) => {
  const { label, style } = displayStatus(status, run);
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style}`}>{label}</span>;
};
